const loadFiveNineScripts = callback => {
  const existinFive9ChatScript = document.getElementById('five9-chat-script');
  const existinFive9ChatWidgetScript = document.getElementById(
    'five9-chat-widget-script'
  );
  if (
    process.env.REACT_APP_FIVE_NINE_CHAT_WIDGET_SCRIPT &&
    !existinFive9ChatWidgetScript
  ) {
    const scriptWidget = document.createElement('script');
    scriptWidget.src = process.env.REACT_APP_FIVE_NINE_CHAT_WIDGET_SCRIPT;
    scriptWidget.id = 'five9-chat-widget-script';
    scriptWidget['data-testid'] = 'five9-chat-widget-script';
    document.head.appendChild(scriptWidget);
    scriptWidget.addEventListener('load', () => {
      if (
        process.env.REACT_APP_FIVE_NINE_CHAT_SCRIPT &&
        !existinFive9ChatScript
      ) {
        const script = document.createElement('script');
        script.src = process.env.REACT_APP_FIVE_NINE_CHAT_SCRIPT;
        script.async = true;
        script.setAttribute('data-id', 'commonWidgetESM');
        script.setAttribute('data-testid', 'five9-chat-script');
        script.type = 'module';
        script.id = 'five9-chat-script';
        document.head.appendChild(script);
      }
      if (typeof callback === 'function') callback();
    });
  }

  if (
    existinFive9ChatScript &&
    existinFive9ChatWidgetScript &&
    typeof callback === 'function'
  )
    callback();
};

export default loadFiveNineScripts;
